import ItemPriceAndCTAs from '../common/ItemPriceAndCTAs'
import SuggestionCTAs from '../CTAContent/SuggestionCTAs'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
}

function CustomSuggestionCTAs({ item }: Props) {
  return (
    <ItemPriceAndCTAs>
      <div className="cta-area">
        <SuggestionCTAs item={item} />
      </div>
    </ItemPriceAndCTAs>
  )
}

export default CustomSuggestionCTAs
